export default __webpack_public_path__ + "static/media/yy.037a8707.PNG";